// var my_accordion = van11yAccessibleAccordionAria();
// my_accordion.attach(document.getElementById('newContent'));

// var other_accordion = van11yAccessibleAccordionAria({
//   ACCORDION_PREFIX_IDS: 'peekaboo_',
//   ACCORDION_JS: 'js-accordion2',
// });
// other_accordion.attach();

const init_accordions = () => {
  const Accordions = document.querySelectorAll('ally-accordion');

  if (Accordions.length) {
    for (let i = 0; i < Accordions.length; i++) {
      Accordions[i].classList.add(`accordion-item-${i}`);

      const single_accordion = van11yAccessibleAccordionAria({
        ACCORDION_PREFIX_IDS: 'kemijarvi',
        ACCORDION_JS: 'accordion-item-' + i,
      });
      single_accordion.attach();
    }
  }
};

/**
 * Init accordion
 */
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.ally-accordion').length > 0) {
    try {
      init_accordions();
    } catch (e) {
      console.log(e);
    }
  }
});
